import { Store, applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { ApplicationState } from "../types";
import { storeReducer } from "./index";

export default function configureStore(initialState: ApplicationState): Store<ApplicationState> {
	const middlewares = [thunk];
	return createStore(storeReducer, initialState, applyMiddleware(...middlewares));
}
